"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Translate_1 = require("./Translate");
exports.default = Translate_1.default;
exports.translate = Translate_1.translate;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-method-component/dist/src/components/Translate/index.js
// module id = 13
// module chunks = 0 1